import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, {useEffect, useState} from 'react';
import {agregarStringAArraydDeStringsSiNoExiste, eliminarStringDeArraydDeStrings, stringSeEncuentraEnArray} from '../../helper/utils';
import {saveEjecutarProcesoEmpleadoAPI} from "../../consumers/backendApisUrls";
import {useManagePostRequest} from "../../hooks/useManagePostRequest/useManagePostRequest";
import GenericTooltip from "../../components/GenericTooltip/GenericTooltip";
import AccionIconoButton, {COLORES_ACCION} from "./AccionIconoButton";
import EstadoProcesoBadge from "./EstadoProcesoBadge";

const TableWebBody = ({
                          filas,
                          toggleDetalleModal,
                          eliminar,
                          idsFichasColaboradoresConCheck,
                          setIdsFichasColaboradoresConCheck,
                          toggleDetalleColaboradorModal,
                          bloquearColaborador,
                          desBloquearColaborador,
                          initialResponse,
                          manageSearchProxy,
                          toggleObservarRegistroModal,
                          toggleRegistrarNotasModal,
                          usuarioLogueadoTieneRolCompensaciones,
                          usuarioLogueadoTieneRolAprobadorSeleccion,
                          usuarioLogueadoTieneRolDupla
                      }) => {

    const [managePostRequest] = useManagePostRequest();
    const [filasLocal, setFilasLocal] = useState([]);

    useEffect(() => {
        mapFilasLocal();
    }, [filas, idsFichasColaboradoresConCheck]);

    const checkboxClic = (e, IdProcesoCierreEmpleado) => {
        let value = e.target.checked;
        let tempFichas = [...idsFichasColaboradoresConCheck];

        if (value === true && !stringSeEncuentraEnArray(IdProcesoCierreEmpleado, tempFichas)) {
            tempFichas = agregarStringAArraydDeStringsSiNoExiste(IdProcesoCierreEmpleado, tempFichas);
            setIdsFichasColaboradoresConCheck(tempFichas);
        } else if (value === false && stringSeEncuentraEnArray(IdProcesoCierreEmpleado, tempFichas)) {
            tempFichas = eliminarStringDeArraydDeStrings(IdProcesoCierreEmpleado, tempFichas);
            setIdsFichasColaboradoresConCheck(tempFichas);
        }
    };

    const saveEjecutarProcesoEmpleado = async function (idProcesoCierreEmpleado) {
        let payload = {
            "IdProcesoCierreEmpleado": idProcesoCierreEmpleado,
        }
        await managePostRequest(saveEjecutarProcesoEmpleadoAPI(), payload, manageSearchProxy);
    }

    const mapFilasLocal = function () {
        let tempArray = filas.map((item) => {
            let itemFound = idsFichasColaboradoresConCheck.find((idSelected, index, array) => idSelected === item.IdProcesoCierreEmpleado);

            if (itemFound === undefined) {
                return {...item, 'checked': false};
            } else {
                return {...item, 'checked': true};
            }
        })

        setFilasLocal(tempArray)
    }

    return (
        <tbody className="listar-tbody">
        {filasLocal.map((fila, i) => (
            <tr key={i}>
                <td className="col-1 pl-1 pr-1">
                    {initialResponse.ExtraData?.PuedeAcciones === true &&
                    <input type="checkbox" defaultChecked={fila.checked} onClick={(e) => checkboxClic(e, fila?.IdProcesoCierreEmpleado)}></input>
                    }
                    {fila?.Empleado}
                </td>
                <td className="col-1 pl-1 pr-1">{fila?.Cargo}</td>
                {<td className="col-1 pl-1 pr-1">{fila?.Departamento}</td>}
                <td className="col-1 pl-1 pr-1">{fila?.Sede}</td>
                {(usuarioLogueadoTieneRolCompensaciones || usuarioLogueadoTieneRolAprobadorSeleccion || usuarioLogueadoTieneRolDupla) && <td className="col-1 pl-1 pr-1">{fila?.OldTipoContrato}</td>}

                {(usuarioLogueadoTieneRolCompensaciones || usuarioLogueadoTieneRolAprobadorSeleccion || usuarioLogueadoTieneRolDupla) && <td className="col-1 pl-1 pr-1">{fila?.FechaFinContrato.replaceAll(" ", "")}</td>}
                <td className="col-1 pl-1 pr-1">{fila?.Condicion}</td>
                <td className="col-1 pl-1 pr-1">
                    <EstadoProcesoBadge idEstado={fila?.IdEstadoProceso} estado={fila?.EstadoProceso}/>
                    {fila?.Observacion &&
                    <GenericTooltip id={"observacion" + fila?.IdProcesoCierreEmpleado} text={fila?.Observacion}/>
                    }
                </td>
                {(usuarioLogueadoTieneRolCompensaciones || usuarioLogueadoTieneRolAprobadorSeleccion || usuarioLogueadoTieneRolDupla) &&<td className="col-1 pl-1 pr-1 ">{fila?.EstadoColaborador}</td>}
                {(usuarioLogueadoTieneRolCompensaciones || usuarioLogueadoTieneRolAprobadorSeleccion || usuarioLogueadoTieneRolDupla) &&<td className="col-1 pl-1 pr-1">{fila?.FechaIngreso}</td>}
                {(usuarioLogueadoTieneRolCompensaciones || usuarioLogueadoTieneRolAprobadorSeleccion || usuarioLogueadoTieneRolDupla) && <td className="col-1 pl-1 pr-1">{fila?.NewTipoContrato}</td>}
                
                <td className="col-1 pl-1 pr-1">
                    <div className="d-flex justify-content-start align-items-center">
                        {fila?.PuedeEditar === true &&
                        <AccionIconoButton icon='edit' title="Editar" color={COLORES_ACCION.Editar}
                            onClick={() => toggleDetalleModal(fila?.IdProcesoCierreEmpleado)}/>
                        }
                        {fila?.PuedeEliminar === true &&
                        <AccionIconoButton icon='times' title="Eliminar" color={COLORES_ACCION.Eliminar}
                            onClick={() => eliminar(fila?.IdProcesoCierreEmpleado)}/>
                        }

                        {(fila?.PuedeDesbloquear === true ) &&
                        <AccionIconoButton icon='lock' title="Desbloquear" color={COLORES_ACCION.Bloqueo}
                            onClick={() => desBloquearColaborador(fila?.IdProcesoCierreEmpleado)}/>
                        }

                        {(fila?.PuedeBloquear === true ) &&
                        <AccionIconoButton icon='lock-open' title="Bloquear" color={COLORES_ACCION.Bloqueo}
                            disabled={!fila.PuedeInteractuarBloqueo}
                            onClick={() => bloquearColaborador(fila?.IdProcesoCierreEmpleado)}/>
                        }

                        {(fila?.PuedeObservar === true ) &&
                        <AccionIconoButton icon='exclamation-triangle' title="Observar" color={COLORES_ACCION.Observar} 
                            onClick={() => toggleObservarRegistroModal(fila?.IdProcesoCierreEmpleado)}/>
                        }

                        {(fila?.PuedeVerDetalle === true || usuarioLogueadoTieneRolAprobadorSeleccion) &&
                        <AccionIconoButton icon='table' title="Ver detalle" color={COLORES_ACCION.VerDetalle}
                            onClick={() => toggleDetalleColaboradorModal(fila?.IdProcesoCierreEmpleado, fila?.IdEstadoProceso)}/>
                        }
                        {(fila?.PuedeRegistrarNotas === true ) &&
                        <div onClick={() => toggleRegistrarNotasModal(fila?.IdProcesoCierreEmpleado)} className="d-flex hand-pointer ml-1">
                            <span className="badge badge-success badge-number-ceses">{fila?.Notas}</span>
                            <FontAwesomeIcon icon='comment' transform="left-8" size="lg" className="hand-pointer  blue-standard-color" title="Registrar una Nota"/>
                        </div>
                        }
                    </div>

                    {(fila?.Accion ) &&
                    <div className="d-flex justify-content-start">
                        <button className="btn btn-primary generic-button-ficha pt-0 pb-0 ml-0 " onClick={() => saveEjecutarProcesoEmpleado(fila?.IdProcesoCierreEmpleado)}>
                            {fila?.Accion}
                        </button>
                    </div>
                    }

                </td>
                
            </tr>
        ))}
        </tbody>
    );
}

export default TableWebBody;